import { flow } from 'fp-ts/function';
import { merge, pick, set } from 'lodash/fp';
import { createSelector, createStructuredSelector } from 'reselect';

import { MultiCurrencyAmount } from '@mews-distributor/common';

import { getEnterpriseDisplayAvailability } from '../../modules/configuration/selectors';
import { getEnterprise, hasEnterpriseNetPricing } from '../../modules/entities/enterprises/selectors';
import { getCurrentDateEnterpriseLowestPrice } from '../../modules/pricing/views/enterprisesPricing';
import { getCurrentDateAvailableCategoriesSpaceTypeCounts } from '../../selectors/views/categoriesAvailability';
import { ApplicationState } from '../../types';
import { WithEnterpriseId } from '../../types/selectors/selectorPropTypes';
import { getAddressString } from './getAddressString';

export const getViewEnterprise = flow(
    getEnterprise,
    (enterprise) => (enterprise ? set('addressString', getAddressString(enterprise.address), enterprise) : {}),
    pick(['id', 'configurationId', 'introImageId', 'name', 'description', 'addressString'])
);

interface EnterpriseAvailabilityData {
    fromPrice: MultiCurrencyAmount | null;
    spaceTypeCounts: unknown;
    hasNetPricing: boolean;
    displayAvailability?: boolean;
}

const getEnterpriseAvailabilityData = createStructuredSelector<
    ApplicationState,
    WithEnterpriseId,
    EnterpriseAvailabilityData
>({
    fromPrice: getCurrentDateEnterpriseLowestPrice,
    spaceTypeCounts: getCurrentDateAvailableCategoriesSpaceTypeCounts,
    hasNetPricing: hasEnterpriseNetPricing,
    displayAvailability: getEnterpriseDisplayAvailability,
});

export const getEnterpriseWithAvailability = createSelector(getEnterpriseAvailabilityData, getViewEnterprise, merge);
